import { Link as LinkComponent } from 'react-router-dom';
import styled from 'styled-components';
import { StyledInputContainer } from '../common/StyledInputContainer';
export const Wrapper = styled(StyledInputContainer) `
  border-radius: 8px;
  display: block;
  max-height: unset;

  .editor {
    padding: 16px;
    overflow-x: auto;
    min-height: 150px;
    outline: none;
    max-height: ${({ rows }) => rows && `${rows * 36}px`};
    color: ${({ theme }) => theme.colors.black_1};

    a:not(:has(:empty)) {
      text-decoration: underline;
    }
  }

  [data-visible='false'] {
    display: none;
  }
`;
export const ToolbarWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  border: none;
  border-radius: 8px 8px 0 0;
  box-shadow: none;
  padding: 8px 16px;
  background-color: ${({ theme }) => theme.colors.grey01_1};
`;
export const ToolbarItems = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;
export const ToolbarItem = styled.button `
  background: ${({ active, theme }) => (active ? theme.colors.grey30_1 : 'transparent')};
  padding: ${({ withPadding }) => (withPadding ? '5px' : '0')};
  border: none;
  border-radius: 4px;
  outline: 3px solid transparent;
  transition:
    background-color 0.2s,
    outline-color 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover:not(:disabled),
  &:focus:not(:disabled),
  &:active:not(:disabled) {
    outline-color: ${({ theme }) => theme.colors.mainLight};
  }
`;
export const LinkTooltipWrapper = styled.div `
  background: ${({ theme }) => theme.colors.grey00_1};
  border: 1px solid ${({ theme }) => theme.colors.grey10_1};
  ${({ theme }) => theme.shadows.shadowTuna};
  border-radius: 4px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  width: 100%;
  max-width: 300px;
`;
export const Link = styled(LinkComponent) `
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
`;
export const Divider = styled.div `
  width: 1px;
  background: ${({ theme }) => theme.colors.grey30_1};
  align-self: stretch;
`;
export const TextareaWrapper = styled.div `
  display: grid;

  &::after {
    content: attr(data-replicated-value) ' ';
    white-space: pre-wrap;
    visibility: hidden;
    padding: 16px;
    min-height: 150px;
    grid-area: 1 / 1 / 2 / 2;
  }
`;
export const Textarea = styled.textarea `
  overflow: hidden;
  padding: 16px;
  min-height: 150px;
  width: 100%;
  border: none;
  resize: none;
  outline: none;
  font-family: monospace;
  vertical-align: top;
  grid-area: 1 / 1 / 2 / 2;
`;
